// DS: I32
// from Phrac T36082
import React from 'react';
import IconWrap from '../IconWrap';
const CloseBold = (props)=>/*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        width: "0",
        height: "0",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M4 6.182L6.182 4 20 17.818 17.818 20z"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M20 6.182L6.182 20 4 17.818 17.818 4z"
    }))));
CloseBold.displayName = 'CloseBold';
export default CloseBold;

//# sourceMappingURL=CloseBold.js.map